var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModulesHomescreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 58 58",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 42.75C2 36.5368 7.0368 31.5 13.25 31.5C19.4632 31.5 24.5 36.5368 24.5 42.75C24.5 48.9632 19.4632 54 13.25 54C7.0368 54 2 48.9632 2 42.75Z",
    fill: "#d2c156",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14.75C17 8.5368 22.0368 3.5 28.25 3.5C34.4632 3.5 39.5 8.5368 39.5 14.75C39.5 20.9632 34.4632 26 28.25 26C22.0368 26 17 20.9632 17 14.75Z",
    fill: "#d2c156",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 42.75C33 36.5368 38.0368 31.5 44.25 31.5C50.4632 31.5 55.5 36.5368 55.5 42.75C55.5 48.9632 50.4632 54 44.25 54C38.0368 54 33 48.9632 33 42.75Z",
    fill: "#d2c156",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModulesHomescreen);
export default __webpack_public_path__ + "static/media/icon_modules_homescreen.f1e08682e12ffcbf7e350e6b1ea73f3e.svg";
export { ForwardRef as ReactComponent };